import { Layers } from 'lucide-react';

// Toggle « Nouveau sujet » / « Compléter un sujet existant » + dropdown du sujet cible
// + bandeau de rappel en mode enrichissement. showToggle=false quand le parent force la cible.
export default function EnrichmentSwitch({ sousSujets, enrichmentTarget, setEnrichmentTarget, clearEnrichmentTarget, showToggle }) {
    const readyRoots = sousSujets.filter(s => s.status === 'READY');
    return (
        <>
            {showToggle && (
                <div className="ms-seg-wrap">
                    <div className="ms-seg">
                        <button type="button" className={`ms-seg__btn ${!enrichmentTarget ? 'is-active' : ''}`}
                            onClick={() => clearEnrichmentTarget()}>
                            Nouveau sujet
                        </button>
                        <button type="button" className={`ms-seg__btn ${enrichmentTarget ? 'is-active' : ''}`}
                            disabled={readyRoots.length === 0}
                            onClick={() => { const first = readyRoots[0]; if (first) setEnrichmentTarget({ id: first.id, label: first.sous_sujet_label }); }}>
                            Compléter existant
                        </button>
                    </div>
                    {/* Dropdown du sujet cible — visible dès qu'on est en mode "Compléter" */}
                    {enrichmentTarget && readyRoots.length > 0 && (
                        <select
                            value={enrichmentTarget.id}
                            onChange={(e) => {
                                const picked = readyRoots.find(s => s.id === Number(e.target.value));
                                if (picked) setEnrichmentTarget({ id: picked.id, label: picked.sous_sujet_label });
                            }}
                            style={{ flex: 1, minWidth: 200, padding: '4px 8px', borderRadius: 6, border: '1px solid var(--card-border)' }}
                        >
                            {readyRoots.map(s => (
                                <option key={s.id} value={s.id}>{s.sous_sujet_label}</option>
                            ))}
                        </select>
                    )}
                    {readyRoots.length === 0 && (
                        <span style={{ color: 'var(--text-muted)', fontSize: '0.85em', fontStyle: 'italic' }}>
                            (aucun sujet prêt à compléter)
                        </span>
                    )}
                </div>
            )}

            {/* Banner d'info compact en mode enrichissement (juste un rappel visuel) */}
            {enrichmentTarget && (
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px',
                    background: 'rgba(124,58,237,0.08)', border: '1px solid rgba(124,58,237,0.25)',
                    borderRadius: 6, marginBottom: 12, fontSize: '0.85em', color: 'var(--text-muted)',
                }}>
                    <Layers size={14} style={{ color: 'var(--primary, #8B5CF6)', flexShrink: 0 }} />
                    <span>
                        Les nouvelles questions s&apos;ajoutent à <strong style={{ color: 'var(--primary, #8B5CF6)' }}>{enrichmentTarget.label}</strong>
                    </span>
                </div>
            )}
        </>
    );
}
